<nav class="navBar navbar navbar-expand-lg navbar-dark">
  <div class="ml-auto mr-auto text-center"><img src="{{pageBanner}}" alt="" class="logo"></div>
  <div class="collapse navbar-collapse" id="navbarNav">

  </div>
</nav>

<div class="row" *ngIf="showError">
  <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
    <div class="alert alert-danger" [innerHTML]="errorText"></div>
  </div>
</div>
<div class="row p-2" *ngIf="showPage">
  <div class="col-lg-12 col-md-12 col-sm-12">
    <div [innerHTML]="pageText"></div>
  </div>
</div>

<div class="row" *ngIf="showQuestions">

  <div class="col-lg-12 col-md-12 col-sm-12">
    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-2" *ngIf="pageData.validationMessages.length > 0">
        <div class="alert alert-danger">
          <label *ngFor="let msg of pageData.validationMessages" [innerHTML]="msg.message"></label>
        </div>
      </div>

      <div *ngIf="pageData.pageInformation" class="col-lg-12 col-md-12 col-sm-12 col-12 mt-2 text-right">
        <button class="btn btn-light" (click)="openModal('pageInformation')">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle text-info" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
          </svg>
        </button>
        <jw-modal id="pageInformation">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-12 text-right">
              <button class="btn btn-blue mb-1" (click)="closeModal('pageInformation');">Close</button>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 mb-2 text-center">
              <div class="text-center" [innerHTML]="pageData.pageInformation"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-12 text-right">
              <button class="btn btn-blue" (click)="closeModal('pageInformation');">Close</button>
            </div>
          </div>
        </jw-modal>
      </div>

      <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-2" *ngFor="let qg of pageData.questionGroups; let qgcnt = index;">
        <div class="row" *ngIf="qg.visible" id="{{qg.groupName}}">
          <div class="col-lg-2 col-md-2 col-sm-1"></div>
          <div class="col-lg-8 col-md-8 col-sm-10">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <h4 *ngIf="qg.groupText != ''">
                  <span [innerHTML]="qg.groupText"></span>
                  <svg *ngIf="qg.groupInformation" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle ml-2 text-info" viewBox="0 0 16 16" (click)="openModal(qg.groupName + 'Information')">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                  </svg>
                </h4>

                <div *ngIf="qg.instructions != ''">
                  <small class="text-muted" [innerHTML]="qg.instructions"></small>
                </div>
              </div>

              <ng-container *ngIf="qg.style == 'ACCORDION'">
                <div class="accordion accordion-flush" id="accordion_{{qg.groupName}}">
                  <ng-container *ngFor="let q of qg.questions; let i = index">
                    <div *ngIf="q.visible" class="accordion-item" (shown.bs.collapse)="$event.target.parentElement.scrollIntoView()">
                      <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" attr.data-bs-target="#accordion_{{q.questionName}}_{{qgcnt}}" aria-expanded="true" aria-controls="collapseOne">
                          <svg *ngIf="(q.minCount > 0 || q.value.length > 0) && q.value.length >= q.minCount && q.value.length <= q.maxCount" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle text-success" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                          </svg>
                          <svg *ngIf="q.minCount === 0 && q.value.length === 0" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle text-warning" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                          </svg>
                          <svg *ngIf="q.value.length < q.minCount || q.value.length > q.maxCount" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-diamond text-danger" viewBox="0 0 16 16">
                            <path d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134z" />
                            <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
                          </svg>
                          &nbsp;
                          {{ q.questionText }}
                          &nbsp;
                          <small>
                            <em>
                              <ng-container *ngIf="q.value.length < q.minCount">
                                {{ q.minCount }} Required
                              </ng-container>
                              <ng-container *ngIf="q.value.length > q.maxCount">
                                {{ q.maxCount }} Max
                              </ng-container>
                              <ng-container *ngIf="q.value.length > 0">
                                {{ q.value.length }} Uploaded
                              </ng-container>
                              <ng-container *ngIf="q.minCount === 0 && q.value.length === 0">
                                {{ q.value.length }} Uploaded
                              </ng-container>
                            </em>
                          </small>
                        </button>
                      </h2>

                      <div id="accordion_{{q.questionName}}_{{qgcnt}}" class="accordion-collapse collapse" aria-labelledby="headingOne" attr.data-bs-parent="#accordion_{{qg.groupName}}">
                        <div class="accordion-body p-0">
                          <!--THE CHILDREN OF THIS NODE ARE COPIED FROM THE OTHER NODE WITH THIS COMMENT-->
                          <div *ngIf="q.instructions != ''">
                            <small class="text-muted" [innerHTML]="q.instructions"></small>
                          </div>

                          <div *ngIf="q.questionType == 6">
                            <h4 *ngIf="q.questionText != ''">
                              <span [innerHTML]="q.questionText"></span>
                              <svg *ngIf="q.questionInformation" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle ml-2 text-info" viewBox="0 0 16 16" (click)="openModal(q.questionName + i + 'Information')">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                              </svg>
                            </h4>
                          </div>

                          <div *ngIf="q.questionType == 2">
                            <label [innerHTML]="q.questionText" for="{{q.questionName}}_{{qgcnt}}"></label>
                            <svg *ngIf="q.questionInformation" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle ml-2 text-info" viewBox="0 0 16 16" (click)="openModal(q.questionName + i + 'Information')">
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                            </svg>
                            <select name="{{qg.groupName}}_{{qgcnt}}" id="{{q.questionName}}_{{i}}" class="form-control"
                                    (change)="saveAnswer($event)">
                              <option value="">-- Please Select One --</option>
                              <option *ngFor="let item of q.options" value="{{item.value}}"
                                      [selected]="q.value == item.value">
                                {{item.text}}
                              </option>
                            </select>
                            <div class="alert alert-danger" *ngIf="showErrorText">
                              {{errorText}}
                            </div>
                          </div>

                          <div *ngIf="q.questionType == 4">
                            <label for="{{q.questionName}}_{{i}}" [innerHTML]="q.questionText"></label>
                            <svg *ngIf="q.questionInformation" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle ml-2 text-info" viewBox="0 0 16 16" (click)="openModal(q.questionName + i + 'Information')">
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                            </svg>
                            <input type="number" name="{{q.questionName}}_{{qgcnt}}" id="{{q.questionName}}_{{i}}"
                                   class="form-control" (blur)="saveAnswer($event)" value="{{q.value}}" />
                          </div>

                          <div *ngIf="q.questionType == 3">
                            <label for="{{q.questionName}}_{{i}}" [innerHTML]="q.questionText"></label>
                            <svg *ngIf="q.questionInformation" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle ml-2 text-info" viewBox="0 0 16 16" (click)="openModal(q.questionName + i + 'Information')">
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                            </svg>
                            <input type="date" name="{{q.questionName}}_{{qgcnt}}" id="{{q.questionName}}_{{i}}"
                                   class="form-control" (blur)="saveAnswer($event)" value="{{q.value ? q.value.replace('T00:00:00', '') : ''}}" />
                          </div>

                          <div *ngIf="q.questionType == 1">
                            <label for="{{q.questionName}}_{{i}}" [innerHTML]="q.questionText"></label>
                            <svg *ngIf="q.questionInformation" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle ml-2 text-info" viewBox="0 0 16 16" (click)="openModal(q.questionName + i + 'Information')">
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                            </svg>
                            <input type="time" name="{{q.questionName}}_{{qgcnt}}" id="{{q.questionName}}_{{i}}"
                                   class="form-control" (blur)="saveAnswer($event)" value="" />
                          </div>

                          <div *ngIf="q.questionType == 7" class="form-check">
                            <input type="checkbox" class="form-check-input" name="{{q.questionName}}_{{qgcnt}}" id="{{q.questionName}}_{{i}}" (change)="saveAnswer($event)" [checked]="q.value" />
                            <label for="{{q.questionName}}_{{i}}" class="form-check-label" [innerHTML]="q.questionText"></label>
                            <svg *ngIf="q.questionInformation" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle ml-2 text-info" viewBox="0 0 16 16" (click)="openModal(q.questionName + i + 'Information')">
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                            </svg>
                          </div>

                          <div *ngIf="q.questionType == 0">
                            <label for="{{q.questionName}}_{{i}}" [innerHTML]="q.questionText"></label>
                            <svg *ngIf="q.questionInformation" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle ml-2 text-info" viewBox="0 0 16 16" (click)="openModal(q.questionName + i + 'Information')">
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                            </svg>
                            <input type="text" name="{{q.questionName}}_{{qgcnt}}" id="{{q.questionName}}_{{i}}" class="form-control" (change)="saveAnswer($event)" value="{{q.value}}" />
                            <div class="alert alert-danger" *ngIf="showErrorText">
                              {{errorText}}
                            </div>
                          </div>

                          <div *ngIf="q.questionType == 5">
                            <div class="col-lg-12 col-md-12 col-sm-12 text-center mt-3 mb-2">
                              <label for="photoUpload_{{qgcnt}}_{{i}}" class="btn btn-success" [ngClass]="{'rounded-pill': roundedButtons}">{{q.buttonText}}</label>
                              <input id="photoUpload_{{qgcnt}}_{{i}}"
                                     name="photoUpload_{{qgcnt}}_{{i}}"
                                     attr.data-groupindex="{{qgcnt}}"
                                     attr.data-questionindex="{{i}}"
                                     attr.data-questionname="{{q.questionName}}"
                                     type="file"
                                     class="form-control"
                                     style="display: none;"
                                     multiple="multiple"
                                     (change)="fileSelect($event)"
                                     [attr.accept]="q.cameraOnly ? 'image/jpeg' : 'image/jpeg,text/plain'"
                                     [attr.capture]="q.cameraOnly ? 'environment' : null"
                              />
                            </div>

                            <div *ngIf="q.value.length > 0 && !loading[q.questionName]">
                              <app-photoitem *ngFor="let file of q.value;let p = index" [photo]="file" [photoPlace]="p" [question]="i" [group]="qgcnt" (removePhoto)="deletePhoto($event)"></app-photoitem>
                            </div>

                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center mauto" *ngIf="loading[q.questionName]">
                              <div class="spinner-border text-primary" role="status"></div>
                              <div>Uploading {{loading[q.questionName]}}...</div>
                            </div>
                          </div>

                          <div class="col-lg-2 col-md-2 col-sm-1"></div>
                          <br />
                          <div class="col-md-2 col-sm-2"></div>

                          <div *ngIf="q.guidanceImageDisplayType == 0 && q.guidanceImages.length > 0">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 text-center">
                                  <h4>Guidance Photos</h4>
                                </div>
                              </div>

                              <div class="row">

                                <div class="col-12 text-center" *ngIf="!guidancePhoto.hasOwnProperty('url')">
                                  <img id="guidePhoto" src="{{q.guidanceImages[0].url}}" class="photoItem " alt="{{q.guidanceImages[0].Caption}}" />
                                  <div class="text-center">{{q.guidanceImages[0].caption}}</div>
                                </div>

                                <div class="col-12 text-center" *ngIf="guidancePhoto.hasOwnProperty('url')">
                                  <img id="guidePhoto" src="{{guidancePhoto.url}}" class="photoItem " alt="{{guidancePhoto.Caption}}" />
                                  <div class="text-center">{{guidancePhoto.caption}}</div>
                                </div>

                                <div class="col-lg-12 col-m-12 col-sm-12 col-12 ">&nbsp;</div>
                              </div>

                              <div class="row" *ngIf="q.guidanceImages.length > 1">
                                <div class="col-lg-2 col-md-2 col-sm-2 col-2 text-right mt-3" (click)="loadGuidePhoto(-1,qgcnt,i)">
                                  <svg width="1em" height="1em" viewBox="0 0 16 16"
                                       class="bi bi-chevron-double-left ml-auto" fill="currentColor"
                                       xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                          d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                                    <path fill-rule="evenodd"
                                          d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                                  </svg>
                                </div>

                                <div class="col-lg-8 col-m-8 col-sm-8 col-8">
                                  <ul class="list-group list-group-horizontal">
                                    <li class="list-group-item m-0 p-2" *ngFor="let item of q.guidanceImages; let i = index;">
                                      <img src="{{item.url}}" class="thumbNail" alt="{{item.caption}}" />
                                    </li>
                                  </ul>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-2 text-left mt-3" (click)="loadGuidePhoto(1,qgcnt,i)">
                                  <svg width="1em" height="1em" viewBox="0 0 16 16"
                                       class="bi bi-chevron-double-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                          d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z" />
                                    <path fill-rule="evenodd"
                                          d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z" />
                                  </svg>
                                </div>
                              </div>
                              <div class="row pb-2">
                                <div class="col-lg-1 col-md-1 col-sm-1 col-1">&nbsp;</div>
                              </div>
                            </div>
                          </div>

                          <div class="row" *ngIf="q.guidanceImageDisplayType == 1 && q.guidanceImages.length > 0">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                              <button class="btn btn-primary" (click)="openModal('gimages')">Help Images</button>
                              <jw-modal id="gimages">
                                <div class="row">
                                  <div class="col-lg-12 col-md-12 col-12 text-right">
                                    <button class="btn btn-blue mb-1" (click)="closeModal('gimages');">Close</button>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-lg-12 col-md-12 col-sm-12 mb-2 text-center" *ngFor="let photo of q.guidanceImages">
                                    <img src="{{photo.url}}" class="photoItem " alt="{{photo.caption}}" />
                                    <div class="text-center">{{photo.caption}}</div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-lg-12 col-md-12 col-12 text-right">
                                    <button class="btn btn-blue" (click)="closeModal('gimages');">Close</button>
                                  </div>
                                </div>
                              </jw-modal>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" *ngIf="qg.style != 'ACCORDION'">
                <div *ngFor="let q of qg.questions; let i = index">
                  <ng-container *ngIf="q.visible">
                    <!--THE CHILDREN OF THIS NODE ARE COPIED FROM THE OTHER NODE WITH THIS COMMENT-->
                    <div *ngIf="q.instructions != ''">
                      <small class="text-muted" [innerHTML]="q.instructions"></small>
                    </div>

                    <div *ngIf="q.questionType == 6">
                      <h4 *ngIf="q.questionText != ''">
                        <span [innerHTML]="q.questionText"></span>
                        <svg *ngIf="q.questionInformation" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle ml-2 text-info" viewBox="0 0 16 16" (click)="openModal(q.questionName + i + 'Information')">
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                          <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                        </svg>
                      </h4>
                    </div>

                    <div *ngIf="q.questionType == 2">
                      <label [innerHTML]="q.questionText" for="{{q.questionName}}_{{qgcnt}}"></label>
                      <svg *ngIf="q.questionInformation" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle ml-2 text-info" viewBox="0 0 16 16" (click)="openModal(q.questionName + i + 'Information')">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                      </svg>
                      <select name="{{qg.groupName}}_{{qgcnt}}" id="{{q.questionName}}_{{i}}" class="form-control"
                              (change)="saveAnswer($event)">
                        <option value="">-- Please Select One --</option>
                        <option *ngFor="let item of q.options" value="{{item.value}}"
                                [selected]="q.value == item.value">
                          {{item.text}}
                        </option>
                      </select>
                      <div class="alert alert-danger" *ngIf="showErrorText">
                        {{errorText}}
                      </div>
                    </div>

                    <div *ngIf="q.questionType == 4">
                      <label for="{{q.questionName}}_{{i}}" [innerHTML]="q.questionText"></label>
                      <svg *ngIf="q.questionInformation" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle ml-2 text-info" viewBox="0 0 16 16" (click)="openModal(q.questionName + i + 'Information')">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                      </svg>
                      <input type="number" name="{{q.questionName}}_{{qgcnt}}" id="{{q.questionName}}_{{i}}"
                             class="form-control" (blur)="saveAnswer($event)" value="{{q.value}}" />
                    </div>

                    <div *ngIf="q.questionType == 3">
                      <label for="{{q.questionName}}_{{i}}" [innerHTML]="q.questionText"></label>
                      <svg *ngIf="q.questionInformation" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle ml-2 text-info" viewBox="0 0 16 16" (click)="openModal(q.questionName + i + 'Information')">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                      </svg>
                      <input type="date" name="{{q.questionName}}_{{qgcnt}}" id="{{q.questionName}}_{{i}}"
                             class="form-control" (blur)="saveAnswer($event)" value="{{q.value ? q.value.replace('T00:00:00', '') : ''}}" />
                    </div>

                    <div *ngIf="q.questionType == 1">
                      <label for="{{q.questionName}}_{{i}}" [innerHTML]="q.questionText"></label>
                      <svg *ngIf="q.questionInformation" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle ml-2 text-info" viewBox="0 0 16 16" (click)="openModal(q.questionName + i + 'Information')">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                      </svg>
                      <input type="time" name="{{q.questionName}}_{{qgcnt}}" id="{{q.questionName}}_{{i}}"
                             class="form-control" (blur)="saveAnswer($event)" value="" />
                    </div>

                    <div *ngIf="q.questionType == 7" class="form-check">
                      <input type="checkbox" class="form-check-input" name="{{q.questionName}}_{{qgcnt}}" id="{{q.questionName}}_{{i}}" (change)="saveAnswer($event)" [checked]="q.value" />
                      <label for="{{q.questionName}}_{{i}}" class="form-check-label" [innerHTML]="q.questionText"></label>
                      <svg *ngIf="q.questionInformation" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle ml-2 text-info" viewBox="0 0 16 16" (click)="openModal(q.questionName + i + 'Information')">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                      </svg>
                    </div>

                    <div *ngIf="q.questionType == 0">
                      <label for="{{q.questionName}}_{{i}}" [innerHTML]="q.questionText"></label>
                      <svg *ngIf="q.questionInformation" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle ml-2 text-info" viewBox="0 0 16 16" (click)="openModal(q.questionName + i + 'Information')">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                      </svg>
                      <input type="text" name="{{q.questionName}}_{{qgcnt}}" id="{{q.questionName}}_{{i}}" class="form-control" (change)="saveAnswer($event)" value="{{q.value}}" />
                      <div class="alert alert-danger" *ngIf="showErrorText">
                        {{errorText}}
                      </div>
                    </div>

                    <div *ngIf="q.questionType == 5">
                      <div class="col-lg-12 col-md-12 col-sm-12 text-center mt-3 mb-2">
                        <label for="photoUpload_{{qgcnt}}_{{i}}" class="btn btn-success" [ngClass]="{'rounded-pill': roundedButtons}">{{q.buttonText}}</label>
                        <input id="photoUpload_{{qgcnt}}_{{i}}"
                               name="photoUpload_{{qgcnt}}_{{i}}"
                               attr.data-groupindex="{{qgcnt}}"
                               attr.data-questionindex="{{i}}"
                               attr.data-questionname="{{q.questionName}}"
                               type="file"
                               class="form-control"
                               style="display: none;"
                               multiple="multiple"
                               (change)="fileSelect($event)"
                               [attr.accept]="q.cameraOnly ? 'image/jpeg' : 'image/jpeg,text/plain'"
                               [attr.capture]="q.cameraOnly ? 'environment' : null"
                        />
                      </div>

                      <div *ngIf="q.value.length > 0 && !showLoading">
                        <app-photoitem *ngFor="let file of q.value;let p = index" [photo]="file" [photoPlace]="p" [question]="i" [group]="qgcnt" (removePhoto)="deletePhoto($event)"></app-photoitem>
                      </div>

                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center mauto" *ngIf="showLoading">
                        <div class="spinner-border text-primary" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-2 col-md-2 col-sm-1"></div>
                    <br />
                    <div class="col-md-2 col-sm-2"></div>

                    <div *ngIf="q.guidanceImageDisplayType == 0 && q.guidanceImages.length > 0 && !showLoading">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="row">
                          <div class="col-lg-12 col-md-12 col-sm-12 text-center">
                            <h4>Guidance Photos</h4>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-12 text-center" *ngIf="!guidancePhoto.hasOwnProperty('url')">
                            <img id="guidePhoto" src="{{q.guidanceImages[0].url}}" class="photoItem " alt="{{q.guidanceImages[0].Caption}}" />
                            <div class="text-center">{{q.guidanceImages[0].caption}}</div>
                          </div>

                          <div class="col-12 text-center" *ngIf="guidancePhoto.hasOwnProperty('url')">
                            <img id="guidePhoto" src="{{guidancePhoto.url}}" class="photoItem " alt="{{guidancePhoto.Caption}}" />
                            <div class="text-center">{{guidancePhoto.caption}}</div>
                          </div>

                          <div class="col-lg-12 col-m-12 col-sm-12 col-12 ">&nbsp;</div>
                        </div>

                        <div class="row" *ngIf="q.guidanceImages.length > 1">
                          <div class="col-lg-2 col-md-2 col-sm-2 col-2 text-right mt-3" (click)="loadGuidePhoto(-1,qgcnt,i)">
                            <svg width="1em" height="1em" viewBox="0 0 16 16"
                                 class="bi bi-chevron-double-left ml-auto" fill="currentColor"
                                 xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd"
                                    d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                              <path fill-rule="evenodd"
                                    d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                            </svg>
                          </div>

                          <div class="col-lg-8 col-m-8 col-sm-8 col-8">
                            <ul class="list-group list-group-horizontal">
                              <li class="list-group-item m-0 p-2" *ngFor="let item of q.guidanceImages; let i = index;">
                                <img src="{{item.url}}" class="thumbNail" alt="{{item.caption}}" />
                              </li>
                            </ul>
                          </div>
                          <div class="col-lg-2 col-md-2 col-sm-2 col-2 text-left mt-3" (click)="loadGuidePhoto(1,qgcnt,i)">
                            <svg width="1em" height="1em" viewBox="0 0 16 16"
                                 class="bi bi-chevron-double-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd"
                                    d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z" />
                              <path fill-rule="evenodd"
                                    d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z" />
                            </svg>
                          </div>
                        </div>
                        <div class="row pb-2">
                          <div class="col-lg-1 col-md-1 col-sm-1 col-1">&nbsp;</div>
                        </div>
                      </div>
                    </div>

                    <div class="row" *ngIf="q.guidanceImageDisplayType == 1 && q.guidanceImages.length > 0">
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <button class="btn btn-primary" (click)="openModal('gimages')">Help Images</button>
                        <jw-modal id="gimages">
                          <div class="row">
                            <div class="col-lg-12 col-md-12 col-12 text-right">
                              <button class="btn btn-blue mb-1" (click)="closeModal('gimages');">Close</button>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 mb-2 text-center" *ngFor="let photo of q.guidanceImages">
                              <img src="{{photo.url}}" class="photoItem " alt="{{photo.caption}}" />
                              <div class="text-center">{{photo.caption}}</div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-12 col-md-12 col-12 text-right">
                              <button class="btn btn-blue" (click)="closeModal('gimages');">Close</button>
                            </div>
                          </div>
                        </jw-modal>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="row mb-5">
        <div class="col-12 col-lg-12 col-md-12 col-sm-12">
          <!-- extra row after the last question for padding purposes  -->
          &nbsp;
        </div>
      </div>
    </div>

    <div class="row fixed-bottom p-3" style="background-color: white;">
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 text-center">
        <div class="dropdown" *ngIf="pageData.languages.length > 1">
          <div class="btn dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
            <img src="assets/langicon.png" alt="Language Selector" />
          </div>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li *ngFor="let langStr of pageData.languages; let ii = index"><div class="dropdown-item hand" [ngClass]="{'active': setActive(langStr)}" (click)="setLanguage(langStr)">{{ lookUpLnaguage(langStr) }}</div></li>
          </ul>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-center">
        <button class="btn btn-success form-control" [ngClass]="{'rounded-pill': roundedButtons}" (click)="nextQuestion(0)"
                *ngIf="pageData.previous.visible"
                [attr.disabled]="showLoading ? 'disabled' : null">
          {{pageData.previous.text}}
        </button>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-center">
        <button class="btn btn-success form-control" [ngClass]="{'rounded-pill': roundedButtons}" (click)="nextQuestion(1)"
                *ngIf="pageData.next.visible"
                [attr.disabled]="showLoading ? 'disabled' : null">
          {{pageData.next.text}}
        </button>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 text-center" *ngIf="pageData.questionnaireInformation">
        <button class="btn btn-light" (click)="openModal('questionnaireInformation')">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle text-info" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
          </svg>
        </button>
        <jw-modal id="questionnaireInformation">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-12 text-right">
              <button class="btn btn-blue mb-1" (click)="closeModal('questionnaireInformation');">Close</button>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 mb-2 text-center">
              <div class="text-center" [innerHTML]="pageData.questionnaireInformation"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-12 text-right">
              <button class="btn btn-blue" (click)="closeModal('questionnaireInformation');">Close</button>
            </div>
          </div>
        </jw-modal>
      </div>
    </div>

    <!--
      Output a modal for all question and question groups with group information.
      group id = qg.groupName + Information e.g. GroupAInformation
      question id = q.questionName + i + Information e.g. QuestionName0Information
    -->
    <ng-container *ngFor="let qg of pageData.questionGroups; let qgcnt = index;">
      <jw-modal *ngIf="qg.groupInformation" id="{{qg.groupName}}Information">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 text-right">
            <button class="btn btn-blue mb-1" (click)="closeModal(qg.groupName + 'Information');">Close</button>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 mb-2 text-center">
            <div class="text-center" [innerHTML]="qg.groupInformation"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 text-right">
            <button class="btn btn-blue" (click)="closeModal(qg.groupName + 'Information');">Close</button>
          </div>
        </div>
      </jw-modal>

      <ng-container *ngFor="let q of qg.questions; let i = index;">
        <jw-modal *ngIf="q.questionInformation" id="{{q.questionName}}{{i}}Information">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-12 text-right">
              <button class="btn btn-blue mb-1" (click)="closeModal(q.questionName + i + 'Information');">Close</button>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 mb-2 text-center">
              <div class="text-center" [innerHTML]="q.questionInformation"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-12 text-right">
              <button class="btn btn-blue" (click)="closeModal(q.questionName + i + 'Information');">Close</button>
            </div>
          </div>
        </jw-modal>
      </ng-container>

    </ng-container>
  </div>
</div>
